import { EMAIL_SIGN_OFF } from './emailSignOff';

export interface ClientPriceListEmailTemplateParams {
  clientName?: string | null;
  link: string;
}

/**
 * Default email body for sharing a Client Price List. Regenerated by "Restore default"
 * with the latest name/link so it never goes stale even after the user edits it.
 */
export function buildDefaultClientPriceListEmailDescription({
  clientName,
  link,
}: ClientPriceListEmailTemplateParams): string {
  const greetingName = (clientName || '').trim() || 'Client';
  return `Dear ${greetingName},

Please find your latest price list attached.

You can also access it online using the secure link below:

${link}

Please let us know if you have any questions.

${EMAIL_SIGN_OFF}`;
}
